import { Link } from 'react-router-dom';
import type { Article } from '@/types/news';
import { formatNumber } from '@/utils/news';

export default function HotRanking({ articles }: { articles: Article[] }) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-900">
          <i className="ri-fire-fill text-accent-500"></i>
          实时热搜榜
        </h2>
        <span className="flex items-center gap-1 text-xs text-foreground-400">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-500 animate-pulse-dot"></span>
          实时更新
        </span>
      </div>
      <ol className="flex flex-col divide-y divide-background-200">
        {articles.map((item, index) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.id}`}
              className="group flex items-start gap-3 py-3 transition-colors"
            >
              <span
                className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                  index < 3 ? 'bg-accent-500 text-background-50 dark:text-foreground-950' : 'bg-background-200 text-foreground-600'
                }`}
              >
                {index + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                  {item.title}
                </span>
                <span className="mt-1 flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-fire-line text-accent-500"></i>
                  {formatNumber(item.hot)}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}